import { render } from "./CompanyInfos.vue?vue&type=template&id=52d319d4&scoped=true"
import script from "./CompanyInfos.vue?vue&type=script&lang=js"
export * from "./CompanyInfos.vue?vue&type=script&lang=js"

import "./CompanyInfos.vue?vue&type=style&index=0&id=52d319d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d319d4"]])

export default __exports__